import { HeaderFields, HeaderProps } from '../components/navigationItem/types/navigationItem.types';
import { newNavigationItemModel, TNavigationItemModel } from '../components/navigationItem/models/navigationItem.model';
import { StringField } from '../../../types/types';

export class HeaderModel {
  public readonly fields: HeaderFields;
  public readonly navigationItemModelsArr: TNavigationItemModel[];
  public readonly mobileTitle: StringField;
  public readonly mobileTitleOpen: StringField;

  constructor(props: HeaderProps) {
    this.fields = props?.fields as HeaderFields;

    if (this.fields?.primaryHeaderMenuLinks && Array.isArray(this.fields?.primaryHeaderMenuLinks)) {
      this.navigationItemModelsArr = this.fields?.primaryHeaderMenuLinks
        .filter((menuLinks) => {
          const fields = menuLinks.fields;
          const linkType = fields?.linkType;
          const keyPhrase = linkType?.fields?.Key?.value || linkType?.fields?.Phrase?.value;
          if (keyPhrase === 'headerMenuDropdownLink') {
            // check if all 4 sections are not defined or empty
            const isEmpty =
              (!fields?.section1 || fields?.section1.length === 0) &&
              (!fields?.section2 || fields?.section2.length === 0) &&
              (!fields?.section3 || fields?.section3.length === 0) &&
              (!fields?.section4 || fields?.section4.length === 0);
            return !isEmpty;
          }
          return true;
        })
        .map((navigationItemData) => {
          return newNavigationItemModel(navigationItemData.fields, navigationItemData?.id, navigationItemData.displayName);
        });
    }
    this.mobileTitle = this.fields?.mobileTitle || { value: 'Menu' };
    this.mobileTitleOpen = this.fields?.mobileTitleOpen || { value: 'Close' };
  }
}
